<template>
  <div class="main-layout">
    <router-view />
  </div>
</template>

<script>
export default {
  components: {
  },
}
</script>
